import React from 'react';

import { Choice, Group, RadioChoice, Toggle } from './OptionControls';

const HORIZONS = [30, 60, 90, 180];

/**
 * The procurement section's options: which blocks the page shows, the lowest
 * priority the overdue list includes, how far ahead awards due look, and
 * which value every table and tile shows.
 */
const ProcurementOptions = ({ options, readOnly, onChange }) => {
    const set = (changes) => onChange({ ...options, ...changes });
    const toggle = (key) => () => set({ [key]: !options[key] });

    return (
        <div className="tw-flex tw-flex-col tw-mt-3 tw-ps-4 tw-border-s-2 tw-border-charcoal-15">
            <Group title={$t('Show')}>
                <Toggle
                    label={$t('Headline tiles')}
                    hint={$t('Open, overdue, high priority overdue, awards due')}
                    checked={!!options.show_tiles}
                    disabled={readOnly}
                    onChange={toggle('show_tiles')}
                />
                <Toggle
                    label={$t('Pipeline by status')}
                    hint={$t('Not Started to Awarded, count and value')}
                    checked={!!options.show_pipeline}
                    disabled={readOnly}
                    onChange={toggle('show_pipeline')}
                />
                <Toggle label={$t('Overdue by priority and complexity')} checked={!!options.show_matrix} disabled={readOnly} onChange={toggle('show_matrix')} />
                <Toggle label={$t('Overdue list')} checked={!!options.show_overdue_list} disabled={readOnly} onChange={toggle('show_overdue_list')} />
                <Toggle label={$t('Awards due')} checked={!!options.show_awards_due} disabled={readOnly} onChange={toggle('show_awards_due')} />
            </Group>
            <Group title={$t('Values')}>
                <RadioChoice
                    name="mp-procurement-value-basis"
                    label={$t('Value shown')}
                    value={options.value_basis}
                    choices={[
                        { value: 'budget', label: $t('Budget') },
                        { value: 'latest_estimate', label: $t('Latest estimate') },
                        { value: 'awarded', label: $t('Awarded value') },
                    ]}
                    disabled={readOnly}
                    onChange={(value) => set({ value_basis: value })}
                />
            </Group>
            <Group title={$t('Lists')}>
                <Choice
                    id="mp-procurement-min-priority"
                    label={$t('Minimum priority to list')}
                    value={options.min_priority}
                    choices={[
                        { value: 'high', label: $t('High priority') },
                        { value: 'medium', label: $t('High and medium') },
                        { value: 'all', label: $t('All') },
                    ]}
                    disabled={readOnly}
                    onChange={(value) => set({ min_priority: value })}
                />
                <Choice
                    id="mp-procurement-horizon"
                    label={$t('Awards due horizon')}
                    value={options.horizon_days}
                    choices={HORIZONS.map((days) => ({ value: days, label: $t('{{count}} days', { count: days }) }))}
                    disabled={readOnly}
                    onChange={(value) => set({ horizon_days: value })}
                />
            </Group>
        </div>
    );
};

export default ProcurementOptions;
